//@ts-ignore
import { CLESSON_MODES, EVALUABLE_CLESSON_MODES } from '@yandex-int/k-common/constants';

export const getIsLessonEvaluable = (mode?: CLESSON_MODES | null): boolean =>
    EVALUABLE_CLESSON_MODES.includes(Number(mode));
